/**
 * FILE-OVERVIEW:
 * - 役割: スケジュール画面モバイル用の下部ナビゲーション。項目の中身だけを決める。
 * - 主な連携: CalendarMain.tsx, Common/BottomNavBar.tsx
 * - 本番運用上の注意: 見た目は BottomNavBar 側にあるため、位置やサイズの変更は
 *   メモ画面のナビにも影響する。
 */

import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ListIcon from '@mui/icons-material/List';

import BottomNavBar from '../Common/BottomNavBar';
import type { BottomNavItem } from '../Common/BottomNavBar';
import { createViewChangeHandler } from '../../utils/eventHelpers';
import type { CalendarStateApi } from '../../utils/eventHelpers';

interface MobileNavigationProps {
  calendarState: CalendarStateApi;
}

const MobileNavigation = ({ calendarState }: MobileNavigationProps) => {
  const handleViewChange = createViewChangeHandler(calendarState);
  const currentView = calendarState.currentView;

  const navItems: BottomNavItem[] = [
    {
      key: 'prev',
      label: '前へ',
      icon: <ArrowBackIcon fontSize="small" />,
      onClick: () => calendarState.calendarRef.current?.getApi().prev(),
      isActive: false,
    },
    {
      key: 'day',
      label: '日',
      icon: <CalendarTodayIcon fontSize="small" />,
      onClick: () => handleViewChange('dayGridDay'),
      isActive: currentView === 'dayGridDay',
    },
    {
      key: 'list',
      label: 'リスト',
      icon: <ListIcon fontSize="small" />,
      onClick: () => handleViewChange('listWeek'),
      isActive: currentView === 'listWeek',
    },
    {
      key: 'today',
      label: '今日',
      icon: <EventAvailableIcon fontSize="small" />,
      onClick: () => calendarState.calendarRef.current?.getApi().today(),
      isActive: false,
    },
    {
      key: 'next',
      label: '次へ',
      icon: <ArrowForwardIcon fontSize="small" />,
      onClick: () => calendarState.calendarRef.current?.getApi().next(),
      isActive: false,
    },
  ];

  return <BottomNavBar className="mobile-bottom-nav" items={navItems} />;
};

export default MobileNavigation;
